var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "url(#pattern0_1669_195803)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1669_195803",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1669_195803",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1669_195803",
    width: 60,
    height: 60,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAAPAAAAACL3+lcAAAEEUlEQVRoBe1ZOWsVURSOohEX1KhJoVY2NmqjUVu11yYkjUUCYizFQnEr1cIui/4BBUUsEsVSbMUFtHEFiStBA0aDO+r3Pd7A4XNmMnPfvfPGxxz4mDl3Octdz723ra2iqgWqFqhaoGqB8rbAHM+mzYW8rcBOYDOwHlgNLAFIM8Bb4DFwD7gJ3AF+A/8VrYW1Z4BXwJ+cYJ3TwBqg9LQSFp4DvgN5HdXy3yBjFFgBlJL6YNV7QA1vlKfM3jJ5PA/GsFeTHPuIvAvAPqAb6ATm18F/pjHvIjANJMkZQR51NZUWQvs1IM7IR0jvB1gmK7HsAMBFLE7mONLzyENxf8TWjnP2C9IPAo30BuseAihLHR9rUDaqu9F5VFNjXiNti5u42Foc7m8A1TMcWzpgIhcoNeI+0rjH+ibKpGzV1+NbUZI8bj26GrNnQzgb2cDF7SlgnZ4E3xEVCPnVFZnzzOcwTrJ9AzJ0Tg8lFfaVzgiKAYFtaS5QRdFxKLK6v4IPObJq4aJVyK2nkdU4b0MtRgVdxE7lFZK1PA8CGhv3Z63ssdwgZNlGnwBP27zTdki0ihhBNSMIWAS9n8QWbl9OlNZSO0TidfCcQ0UTF64bopTHTydKc1hX4ltOGvxU4rnZktpm81L/0xzm4d3SA8sU/K+61TYv5kxBip3Dq7xIdRPSJbYwEPJOeqhv964hu8AFKGobn7GBE6UNaSeBBVVyvotLc3hGjF8qfJHsMlGmtkl2Mpvm8Duptk74IlnVzcOLE6U5/EQkbhK+SFZ1P3dVnubwXRGqgYhkB2V3ifTbwntht0GKXRmnwTcjtOQB4rPY4hxaQk4isff18DCQWDpcxgGItg3/ErzzKj2bmXwRsMp4u1j08ZBPM9aGY7MZ3Ug+nz/0AoC3i0XRSSiyzvLUtDy08lFRytNLkDkkjmwET13W4bNSJggbd4nHW4iQVy2dkP8MsM5OgNcABElhqBdirXL+8yqVhvkmyuRTqtXH51Tdmnzr/UfeiBhBg3iVyttFX8RhrD1LPVd9Kcgjh6vzOGBbnv+cZ7xd5H7pSqx7AtA5G+n6ibw+V+GN1GPgMQZEhtgv5/UgwDuorMSy3Gd167Fyo/+mOc2e5ltPZIh+uXVcAvYDjNY4J9vr6KqnsWEuAxpBRbI4ZzmM6WSUxm/TnIbuth5gErAG+fjnahwtUBzGpXK6AwYNARqcuDjOkcF9Vree0jkNG2t7Ml8E2Dt5nWVsfBRIi6BK6TRsrr0IdON7BLgCPASmAN6P/QA+ALyB5Pw8DLBs1oNAaZ2GD8GI64bO6V9I2xtMYwkEV06jE7huVD1dgtHo3YSkhWyPd00lEhjnNLe6liZ1mrF5yxOH8QuAvbu75b2tHKxaoGqBqgVasgX+Ao392IIezbC/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLens);
export default __webpack_public_path__ + "static/media/searchLens.cdc5f5d87e4657a35a897dbbcfe206f3.svg";
export { ForwardRef as ReactComponent };